import { render, staticRenderFns } from "./OnboardingSection.vue?vue&type=template&id=98d792a8&"
import script from "./OnboardingSection.vue?vue&type=script&lang=js&"
export * from "./OnboardingSection.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSection.vue?vue&type=style&index=0&lang=less&module=true&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./OnboardingSection.vue?vue&type=style&index=0&lang=less&module=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./OnboardingSection.vue?vue&type=style&index=0&lang=less&module=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("98d792a8")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98d792a8')) {
      api.createRecord('98d792a8', component.options)
    } else {
      api.reload('98d792a8', component.options)
    }
    module.hot.accept("./OnboardingSection.vue?vue&type=template&id=98d792a8&", function () {
      api.rerender('98d792a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/onboarding/components/OnboardingSection.vue"
export default component.exports